<template>
  <textarea
    v-model="text"
    disabled
    class="tw-rounded-md tw-bg-[#EEEFF2] tw-text-[#1F2229] tw-border-none tw-p-3 tw-resize-none tw-h-40 tw-w-full no-scrollbar"
    placeholder="Enter your text here..."
  />
</template>

<script>

export default {
  components: { },
  props: ['initialText'],
  data() {
    return { text: this.initialText };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: {
    initialText(newVal) {
      this.text = newVal;
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>

<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
</style>

